import React from 'react';

// Match native identifier hashing; list reordering must not change a person's color.
export function avatarStyle(identifier: string): React.CSSProperties {
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  return { backgroundColor: `var(--vs-avatar-palette-${Math.abs(hash) % 12})`, color: 'var(--vs-avatar-text)' };
}

/** Decorative avatar: the adjacent name supplies the accessible identity. */
export default function PersonAvatar({ name, src, identifier }: { name: string; src?: string; index?: number; identifier?: string }) {
  const [failedSource, setFailedSource] = React.useState<string>();
  return (
    <span className="vs-avatar" style={avatarStyle(identifier || name)} aria-hidden="true">
      {src && src !== failedSource ? (
        <img src={src} alt="" onError={() => setFailedSource(src)} />
      ) : ((name || '').trim().slice(0, 1).toUpperCase() || '?')}
    </span>
  );
}
